export enum SA_TIME_UNIT {
  MINUTE = 'minute',
  HOUR = 'hour',
}
